module.exports = __webpack_public_path__ + "img/twitter-blue.07b8bb94.svg";